import React from 'react';
import './Produtos.css';

const Produtos: React.FC = () => {
  return (
    <section id="produtos" className="produtos">
      <div className="container">
        <h2 className="section-title">Nossos Produtos</h2>
        <p className="section-subtitle">
          Oferecemos milho premium de alta qualidade, com grãos selecionados
          e sabor autêntico para todas as suas necessidades culinárias.
        </p>

        <div className="produto-destaque">
          <div className="produto-info">
            <div className="produto-badge">⭐ Produto Premium</div>
            <h3>Garcias Milho Premium</h3>
            <p className="produto-subtitle">
              Nossa mais nova estrela! 🌽 Milho selecionado, com grãos suculentos
              e sabor marcante — perfeito para pratos típicos, acompanhamentos ou
              receitas criativas.
            </p>

            <div className="produto-caracteristicas">
              <h4>Características:</h4>
              <ul>
                <li>Grãos selecionados de alta qualidade</li>
                <li>Sabor autêntico e marcante</li>
                <li>Textura perfeita para diversos preparos</li>
                <li>Processamento que preserva nutrientes</li>
                <li>Ideal para uso comercial e doméstico</li>
              </ul>
            </div>

            <div className="produto-aplicacoes">
              <h4>Aplicações:</h4>
              <div className="aplicacoes-grid">
                <div className="aplicacao">
                  <span className="aplicacao-icon">🍽️</span>
                  <span>Pratos Típicos</span>
                </div>
                <div className="aplicacao">
                  <span className="aplicacao-icon">🥗</span>
                  <span>Acompanhamentos</span>
                </div>
                <div className="aplicacao">
                  <span className="aplicacao-icon">👨‍🍳</span>
                  <span>Receitas Criativas</span>
                </div>
                <div className="aplicacao">
                  <span className="aplicacao-icon">🏪</span>
                  <span>Uso Comercial</span>
                </div>
              </div>
            </div>
          </div>

          <div className="produto-imagem">
            <img src="/images/garcias-milho-produto.svg" alt="Garcias Milho Premium" />
            <div className="produto-cta">
              <h4>Interessado?</h4>
              <p>Entre em contato conosco para mais informações sobre preços e disponibilidade.</p>
              <a href="#contato" className="btn-contato">
                Solicitar Orçamento
              </a>
            </div>

            <div className="produto-cta" style={{ marginTop: '20px' }}>
              <h4>Mandicas Uberlândia</h4>
              <p>Conheça mais de nossos produtos.</p>
              <a target="_blank" rel="noopener noreferrer" href="https://mandiocasuberlandia.com.br/" className="btn-contato">
                mandiocasuberlandia.com.br
              </a>
            </div>
          </div>


        </div>

        <div className="clientes-alvo">
          <h3>Ideal para:</h3>
          <div className="clientes-grid">
            <div className="cliente">🏪 Supermercados</div>
            <div className="cliente">🥩 Açougues</div>
            <div className="cliente">🛒 Sacolões</div>
            <div className="cliente">🍺 Bares</div>
            <div className="cliente">🍽️ Restaurantes</div>
            <div className="cliente">🏊 Clubes</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Produtos;
